<div class="modal-header">
  <h4 class="modal-title">{{ !urls ? 'Controlla Siti Web' : 'Risultati' }}</h4>
  <button type="button" class="btn-close" i18n-aria-label aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>
@if (!urls) {
<form [formGroup]="checkUrlForm" (ngSubmit)="onCheck()">
  <div class="modal-body">
    <div class="mb-3">
      <label for="urls" class="form-label">Siti web da controllare <small>(una URL per linea)</small></label>
      <textarea class="form-control" id="urls" rows="3" placeholder="www.example.com/nonexistent-page
  *help.fakewebsite.org/missing-product" formControlName="urls"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <app-loading-button [loading]="loading" [disabled]="checkUrlForm.invalid || loading" i18n>Controlla</app-loading-button>
  </div>
</form>
} @else {
<div class="modal-body">
  <table class="table qai-table-striped table-hover qai-table-head_solid">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">Siti web</th>
        <th scope="col">Stato</th>
        <th scope="col">Data</th>
      </tr>
    </thead>
    <tbody>
      @for (item of urls; track $index) {
      <tr [class.table-active]="isSelected(item.url)">
        <td class="px-1 qai-checkbox-cell">
          <div class="form-check d-flex justify-content-center">
            <input class="form-check-input" name="checkbox" type="checkbox" (change)="selectRow(item)"
              (click)="$event.stopPropagation()" [disabled]="item.status === 'NOT_MATCH'" />
          </div>
        </td>
        <td>{{ item.url }}</td>
        <td><app-badge-status [status]="item.status"></app-badge-status></td>
        <td>{{ item.lastRefresedTime | date: 'dd/MM/yyyy' }}</td>
      </tr>
      }
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <app-loading-button [loading]="loading" [disabled]="selectedRows.length < 1 || loading" type="button" (clickButton)="onRecrawl()" i18n>Reindicizza siti web</app-loading-button>
</div>
}